export default __webpack_public_path__ + "static/media/kz.b56a9ead.svg";